<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Outpatient Appointment and Service Hours</h3>
            <p class="depth">You can make an appointment by call, email, or via website. You are required to provide
                your personal information and describe symptoms in details for proper appointment and treatment.</p>
            <div class="table mt20">
                <table>
                    <caption>Outpatient Appointment and Service Hours (For how to make an appointment, Process,
                        Available time)</caption>
                    <colgroup>
                        <col style="width: 25%">
                        <col style="width: auto">
                        <col style="width: 15%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">For how to make an appointment</th>
                            <th scope="col">Process</th>
                            <th scope="col">Available time</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Call</td>
                            <td>Please call the International Healthcare Center (+82-6986-3100)</td>
                            <td>09:00 ~ 17:00</td>
                        </tr>
                        <tr>
                            <td>E-Mail</td>
                            <td><a href="mailto:eumcint@gmail.com">eumcint@gmail.com</a></td>
                            <td>24hour</td>
                        </tr>
                        <tr>
                            <td>Website</td>
                            <td>
                                <div style="display: ruby;">
                                    Service reservation is also available from the hospital's website. Website
                                    &nbsp;&nbsp;
                                    <a href="/eng/reservation/reservation.do"
                                        class="main-button small c-main">Reservation</a>
                                </div>
                            </td>
                            <td>24hour</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">Change or Cancelation of Service (Appointment)</h3>
            <p class="depth">
                If the person who made an appointment cannot come for the service on the scheduled day on account of an
                inevitable reason, the reservation must be changed or canceled at least a day prior to the schedule.
            </p>
            <div class="table mt20">
                <table>
                    <caption>Change or Cancelation of Service (For how to make an appointment, Process)</caption>
                    <colgroup>
                        <col style="width: 25%;">
                        <col>
                    </colgroup>
                    <thead>
                        <tr>
                            <th scope="col">For how to make an appointment</th>
                            <th scope="col">Process</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Call</td>
                            <td>International Healthcare Center (+82-6986-3100)</td>
                        </tr>
                        <tr>
                            <td>E-Mail</td>
                            <td><a href="mailto:eumcint@gmail.com">eumcint@gmail.com</a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>